import { DesktopDatePicker } from '@mui/x-date-pickers';
import { TextFieldProps } from '@mui/material';
import { DateTime } from 'luxon';

import { Input, InputProps } from 'theSource/components/Input';
import { DATE_FORMAT, DATE_FORMAT_PLACEHOLDER } from 'theSource/utils';

export interface DateInputProps extends Omit<InputProps, 'value' | 'onChange'> {
  onChange: (
    value: DateTime | null,
    keyboardInputValue?: string | undefined
  ) => void;
  value: DateTime | null;
}

export const DateInput = ({
  onChange,
  placeholder = DATE_FORMAT_PLACEHOLDER,
  value,
  ...props
}: DateInputProps) => {
  const renderInput = (fieldProps: TextFieldProps) => {
    return (
      <Input
        inputRef={fieldProps.inputRef}
        {...fieldProps.inputProps}
        placeholder={placeholder}
        {...props}
      />
    );
  };

  // disableOpenPicker does not disable mobile picker, using desktop component instead
  return (
    <DesktopDatePicker
      disableOpenPicker
      inputFormat={DATE_FORMAT}
      onChange={onChange}
      renderInput={renderInput}
      value={value}
    />
  );
};
